import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ics-loader',
  template: `
    <div class="loader">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>

  `,
  styles: [`.loader{left:50%;position:absolute;top:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);z-index:999}.loader .dot{-webkit-animation:1s infinite slide;animation:1s infinite slide;background:#0e7cc5;border-radius:100%;display:inline-block;height:24px;width:24px}.loader .dot:nth-child(1){-webkit-animation-delay:.1s;animation-delay:.1s;background:#00ef90}.loader .dot:nth-child(2){-webkit-animation-delay:.2s;animation-delay:.2s;background:#02c580}.loader .dot:nth-child(3){-webkit-animation-delay:.3s;animation-delay:.3s;background:#56c3c0}.loader .dot:nth-child(4){-webkit-animation-delay:.4s;animation-delay:.4s;background:#00b5a6}.loader .dot:nth-child(5){-webkit-animation-delay:.5s;animation-delay:.5s;background:#009494}@-webkit-keyframes slide{0%,100%{-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.3;-webkit-transform:scale(2);transform:scale(2)}}@keyframes slide{0%,100%{-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.3;-webkit-transform:scale(2);transform:scale(2)}}`]

})
export class ICSLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
